(function() {
  'use strict';

  // configure routes
  angular.module(moduleConfig.applicationModuleName).config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('myAccountViewProfile', {
          url: '/myaccount/view-profile',
          title: 'myAccountViewProfile',
          angularRoute: true,
          template: '',
          data: {
            showSubHeading: true,
            authRequired: true
          }
        })
        .state('myAccountPaymentMethod', {
          url: '/myaccount/payment-method',
          angularRoute: true,
          template: '',
          data: {
            showSubHeading: true,
            authRequired: true
          }
        })
        .state('myAccountWireless', {
          url: '/myaccount/wireless',
          title: 'myAccountWireless',
          angularRoute: true,
          template: '',
          data: {
            showSubHeading: true,
            authRequired: true
          }
        })
        .state('registerNow', {
          url: '/register/now',
          angularRoute: true,
          template: ''
        })
        .state('myAccountManageData', {
          url: '/myaccount/manage-data',
          title: 'myAccountWireless-manageData',
          angularRoute: true,
          template: '',
          data: {
            showSubHeading: true,
            authRequired: true
          }
        })
        .state('myAccountRepairClaim', {
          url: '/myaccount/repair-claim',
          title: 'myAccountRepairClaim',
          angularRoute: true,
          template: '',
          data: {
            showSubHeading: false,
            authRequired: true
          }
        });
    }
  ]);
})();
